"use strict";

App.Pages.ListStelles = class ListStelles extends PF.Page
{

    static get options()
    {
        return {
            rights: {
                user: true
            },
            path: '/list-stelles',
            nameRu: 'Стелы - список',
        };
    }

    static get template()
    {
        //language=HTML
        return `
            <div class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">
                    <div class="block">
                        <div class="content-block-title"><h3>Главная</h3></div>
                    </div>
                    <div class="pf-button-toggle row resizable" pf="wrapper">
                        <div class="segmented segmented-raised col-30" pf="ul">
                            <button class="button " type="button" pf="button1">Карта</button>
                            <button class="button button-active" type="button" pf="button2">список</button>
                        </div>
                    </div>

					<div pf="list">

					</div>

				</div>

			</div>

		`;
    }

    init()
    {
        super.init();


        this.list = new PF.List({
            dom: {
                element: this.dom.list,
                scrollTarget: this.dom.pageContent,
            },
            searchable: true,
            modelsConfig: {
                represent: 'stella/manage',
                limit: 10,
            },
            itemClass: Server,
            searchConfig: ' @{name} ~ @{list.searchField} || @{address} ~ @{list.searchField} || @{serverVa.ip} ~ @{list.searchField}'
	
        });
        
        this.dom.button1.on('click', () =>
        {
            app.router.navigate('/main');
        });
    }
};

class Server extends PF.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
			<li pf="item">
                <a href="" class=" item-content item-link" pf="link">
                    <div class="item-inner">
                        <div class="item-title">
                            @{model.name}<br/>
                            @{model.address}
                        </div>
                        <div class="item-after">
                            <span>@{model.district.name}<br/>
                            @{model.serverVa.ip}</span>
                        </div>
    				</div>
    			</a>
			</li>
		`;
    }

    onRender()
    {
        super.onRender();

        this.dom.link.on("click", () =>
        {
            app.pageParams.setData('id', this.model.id);
            app.router.navigate('/stat-stella');
        });
    }

}